import axios from "axios";

export const getConfig = () => (dispatch) => {
  axios.get("/api/config/").then((res) => {
    dispatch({
      type: "SET_CONFIG",
      payload: res.data,
    });
  });
};
